import React, { createContext, useContext, useState, useCallback } from "react";
import { t } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("cp_lang") || "en");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "en" ? "kn" : "en";
      localStorage.setItem("cp_lang", next);
      return next;
    });
  }, []);

  const tr = useCallback((key) => t[lang]?.[key] ?? t.en[key] ?? key, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggle, tr }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
